import axios from 'axios'

export const getLinkMetadata = (link: string) => {
  const URL = `${process.env.REACT_APP_COORDINATOR_URL}/parse-url?url=${link}`
  return axios.get(URL)
}
